import React from 'react';
import {useIntl} from 'react-intl';
import cn from 'classnames';

import {ERecommendationsProviders, ERecommendationsTypes} from 'coreClasses/recommendations/IRecommendationsMgr';

import ProductRecommendation from 'brandComponents/ProductRecommendation';
import Recommendations from 'brandComponents/Recommendations';
import Typography from 'brandComponents/Typography';

import {IProductDetailBottomBlock} from './IProductDetailBottomBlock';
import messages from './messages';

import styles from './ProductDetailBottomBlock.module.scss';

const ProductDetailBottomBlock = ({product}: IProductDetailBottomBlock) => {
	const intl = useIntl();
	//TODO: remove this boolean when we have Einstain CHP-101
	const isRecentlyViewed = false;

	return (
		<>
			<div className={styles['product-detail-bottom-block']}>
				{product.hasStyleItWith() && <div
					className={styles['product-detail-bottom-block-recommended-style-it-with']}
				>
					<Typography variant="h3" classNames={styles['product-detail-bottom-block__title']}>
						{intl.formatMessage(messages.styleItWith)}
					</Typography>
					<Recommendations
						key="product-detail-bottom-block-recommended-style-it-with"
						providerId={ERecommendationsProviders.SFCC}
						type={ERecommendationsTypes.COMPLETE_THE_SET}
						productId={product.getProductId()}
						recommendationComponent={ProductRecommendation}
					/>
				</div>}
				<div className={cn({['d-none']: isRecentlyViewed},
					styles['product-detail-bottom-block-recommended-ymal'])}
				>
					<Typography variant="h3" classNames={styles['product-detail-bottom-block__title']}>
						{intl.formatMessage(messages.youMayAlsoLike)}
					</Typography>
					<Recommendations
						key="product-detail-bottom-block-recommended-ymal"
						providerId={ERecommendationsProviders.EINSTEIN}
						type={ERecommendationsTypes.YOU_MAY_ALSO_LIKE}
						productId={product.getProductId()}
						recommendationComponent={ProductRecommendation}
					/>
				</div>
			</div>
		</>
	);
};

export default ProductDetailBottomBlock;
